module.exports = __webpack_public_path__ + "img/D_Read_more_graph_male.25c9132a.svg";